import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuidePMai() {
  return (
    <GuideLayout
      title="プロジェクト管理に生成AIを活用する方法｜AIで変わるPM業務｜”おもいむすび”"
      description="プロジェクト管理における生成AIの活用方法を解説。AIタスク分解、AI進捗管理、AIスケジュール作成、AIガントチャート、AI日報解析など。AIに任せられることと人が確認すべきことを区別します。"
      keywords="プロジェクト管理 AI活用,プロジェクト管理 生成AI,AI タスク管理,AI 進捗管理,AI ガントチャート,AI WBS"
      canonical="https://omoimusubi.asia/guides/project-management-ai/"
      h1="プロジェクト管理に生成AIを活用する方法"
      subtitle="生成AIをプロジェクト管理に活用することで、タスク分解や進捗管理などの業務を効率化する方法を解説します。AIに任せられることと、人が確認すべきことを明確に区別します。"
      relatedFeatures={[
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
        { label: 'AI日報', path: '/features/ai-daily-report/' },
        { label: 'AIファイル管理', path: '/features/ai-file-management/' },
      ]}
      relatedGuides={[
        { label: 'プロジェクト管理とは', path: '/guides/project-management/' },
        { label: 'WBSとは', path: '/guides/wbs/' },
        { label: 'ガントチャートとは', path: '/guides/gantt-chart/' },
      ]}
    >
      <div className="not-prose mb-8 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20office%20scene%20a%20Japanese%20female%20office%20worker%20in%20her%2030s%20looking%20amazed%20and%20impressed%20at%20her%20laptop%20screen%20the%20laptop%20displays%20an%20AI%20powered%20interface%20with%20glowing%20task%20suggestions%20and%20automated%20workflow%20visualization%20magical%20sparkles%20of%20innovation%20natural%20daylight%20streaming%20through%20large%20windows%20indoor%20plants%20clean%20fresh%20contemporary%20Japanese%20tech%20workspace%20inspiring%20atmosphere&width=1200&height=600&seq=guide-pm-ai-01&orientation=landscape"
          alt="プロジェクト管理に生成AIを活用 - AIの提案に驚く日本人ビジネスパーソン"
          className="w-full h-auto"
        />
      </div>
      <section>
        <h2>生成AIがプロジェクト管理でできること</h2>
        <ul>
          <li><strong>タスクの自動分解</strong>：企画書や提案書から必要な作業を抽出し、WBSを自動生成</li>
          <li><strong>スケジュールの自動計算</strong>：タスクの依存関係やメンバーの稼働状況を考慮した日程調整</li>
          <li><strong>日報の自動解析</strong>：自由形式の日報から進捗状況を抽出し、タスクを自動更新</li>
          <li><strong>資料の内容理解と回答</strong>：アップロードされた資料の内容をAIが理解し、質問に回答</li>
        </ul>
      </section>

      <section>
        <h2>AIに任せられないこと、人が確認すべきこと</h2>
        <p>AIは強力な支援ツールですが、以下の点は人が判断する必要があります。</p>
        <ul>
          <li><strong>最終的な判断と承認</strong>：AIの提案内容をそのまま採用するのではなく、人が確認・修正・承認する</li>
          <li><strong>ステークホルダーとの調整</strong>：顧客や経営層とのコミュニケーションや交渉</li>
          <li><strong>リスクの評価と対策</strong>：AIが検出できない複合的なリスクの判断</li>
          <li><strong>チームのモチベーション管理</strong>：メンバーの状況把握と適切なフォロー</li>
        </ul>
        <p>AIはプロジェクトマネージャーの判断を支援するツールであり、最終的な責任は人が負うことを理解しておくことが重要です。</p>
      </section>
    </GuideLayout>
  );
}